module.exports = __webpack_public_path__ + "img/waltily_logo.bb79334a.svg";